import React, { useState, useEffect, useContext} from "react";

import DatePicker from "react-datepicker";
import { AppContext } from "../../AppContext";

import UserSelectBox from "../common/controls/UserSelectBox";


const GiftFormComp = (props) => {
  const [appContext, setAppContext] = useContext(AppContext);
  const isJwCole = appContext.clientId === "jwcole"?true:false;

  const [showGovRecipients, setShowGovRecipients] = useState(false);
  const [showRaffleContest, setShowRaffleContest] = useState(false);
  
  const [validation, setValidation] = useState({
        valid: true,
        giftType : true,
        description : true,
        giftDate : true,
        address : true,
        giftValue : true,
        currency : true,
        recipients : true,
        providers : true,
        governmentRecipients : true,
        raffleContest:true
      });

      const validate = () => {
        const valid =
            props.data.giftType &&
            props.data.description &&
            props.data.giftDate &&
            (isJwCole || props.data.address) &&
            props.data.giftValue &&
            props.data.recipients &&
            (!isJwCole || props.data.providers) &&
            (props.data.governmentRecipients || props.data.isGovRecipients==='N') &&
            (props.data.raffleContest || props.data.isRaffleContest==='N')
            ? true
            : false;
        setValidation({
          ...validation,
            valid,
            giftType: props.data.giftType ? true : false,
            description: props.data.description ? true : false,
            giftDate: props.data.giftDate ? true : false,
            address: (isJwCole || props.data.address) ? true : false,
            giftValue: props.data.giftValue ? true : false,
            recipients: props.data.recipients ? true : false,
            providers: (!isJwCole || props.data.providers) ? true : false,
            governmentRecipients: (props.data.governmentRecipients || props.data.isGovRecipients==='N') ? true : false,
            raffleContest: (props.data.raffleContest || props.data.isRaffleContest==='N') ? true : false
        });

        console.log(validation);
        return valid;
      };

      
      const handleNumberFieldChange = (e) => {
        if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
          props.handleChange(e);
        }
      };

      const handleSaveClick = (e) => {
        if (!validate()) {
          return;
        }
        props.handleSaveClick(e);
      };
    

    useEffect(()=>{
      setShowGovRecipients(props.data.isGovRecipients === 'Y')
    },[props.data.isGovRecipients])

    useEffect(()=>{
      setShowRaffleContest(props.data.isRaffleContest === 'Y')
    },[props.data.isRaffleContest])

    return (
        <div className="form">
            <div className="form-header">
                <div className="form-header-label">{props.editorMode === "UPDATE"?"Update":"Create a New"} Gifts & Entertainment Request</div>
            </div>
            <div className="form-body">

                <div className="form-items">
                { !isJwCole && <div className="form-desc">All gift giving, entertainment or events must be pre-cleared. Please provide details in the fields below. If required, attach brochures or documentation to this pre-clearance request.</div>}
                  <div className="form-columns">

                    <div className="form-column">

                      <div className="form-item">
                        <label className={`form-item-label required ${validation.giftType ? "" : "warning" }`} htmlFor="giftType">Select the type of gift, event or entertainment request :</label>
                        <div className="form-item-value label-group">
                          <label><input type="radio" name="giftType" value="Gift" className="form-check-input" checked={props.data.giftType === "Gift"} onChange={props.handleChange}/>Gift/Gratuity</label>
                          <label><input type="radio" name="giftType" value="Meal" className="form-check-input" checked={props.data.giftType === "Meal"} onChange={props.handleChange}/>Meal</label>
                          {isJwCole && 
                          <label><input type="radio" name="giftType" value="Business Entertainment" className="form-check-input" checked={props.data.giftType === "Business Entertainment"} onChange={props.handleChange}/>Business Entertainment</label>
                          }
                          {!isJwCole &&
                          (<>
                            <label><input type="radio" name="giftType" value="Accomodation" className="form-check-input" checked={props.data.giftType === "Accomodation"} onChange={props.handleChange}/>Accomodation</label>
                            <label><input type="radio" name="giftType" value="Event" className="form-check-input" checked={props.data.giftType === "Event"} onChange={props.handleChange}/>Event</label>
                          </>
                        )}
                        </div>
                      </div>

                      <div className="form-item">
                        <label className={`form-item-label required ${validation.giftDate ? "" : "warning"}`} htmlFor="giftDate">Given Date or { isJwCole ? "Date Received" : "Planned For" } :</label>
                        <div className="form-item-value">
                          <DatePicker selected={props.data.giftDate} onChange={props.handleDateChange}/>
                        </div>
                      </div>

                      <div className="form-item">
                        <label className={`form-item-label required ${validation.description ? "" : "warning" }`} htmlFor="description">Description :</label>
                        <input className="form-item-value" type="text" id="description" name="description" maxLength="500" value={props.data.description} onChange={props.handleChange}/>
                      </div>
                      {!isJwCole && 
                      <div className="form-item">
                        <label className={`form-item-label required ${validation.address ? "" : "warning" }`} htmlFor="address">Address :</label>
                        <input className="form-item-value" type="text" id="address" name="address" maxLength="500" value={props.data.address} onChange={props.handleChange}/>
                      </div>
                      }
                      <div className="form-item">
                        <label className={`form-item-label required ${validation.giftValue ? "" : "warning" }`} htmlFor="giftValue">{!isJwCole && "Gift "} Value per Person:</label>
                        <input className="form-item-value" type="text" id="giftValue" name="giftValue" value={props.data.giftValue} onChange={handleNumberFieldChange}/>
                      </div>
                      { !isJwCole && 
                        <div className="form-item">
                          <label className={`form-item-label ${validation.currency ? "" : "warning" }`} htmlFor="currency">Currency :</label>
                          <input className="form-item-value" type="text" id="currency" name="currency" maxLength="50"  value={props.data.currency} onChange={props.handleChange}/>
                        </div>
                      }

                      <div className="form-item">
                        <label className={`form-item-label required ${validation.recipients ? "" : "warning" }`} htmlFor="recipients">Recipient(s) :</label>
                        <input className="form-item-value" type="text" id="recipients" name="recipients" maxLength="500" value={props.data.recipients} onChange={props.handleChange}/>
                      </div>

                      {isJwCole &&
                      <div className="form-item">
                        <label className={`form-item-label required ${validation.providers ? "" : "warning" }`} htmlFor="providers">Provider(s) :</label>
                        <input className="form-item-value" type="text" id="providers" name="providers" maxLength="500" value={props.data.providers} onChange={props.handleChange}/>
                      </div>
                      }


                    </div>

                    <div className="form-column">
                      
                      
                      <div className="form-item">
                        <label className={`form-item-label required ${validation.governmentRecipients ? "" : "warning" }`} htmlFor="governmentRecipients">Government Recipients :</label>
                        <div className="form-item-value">
                          <div className="full-width label-group">
                            <label>
                              <input type="radio" name="isGovRecipients" value="N" className="form-check-input" checked={props.data.isGovRecipients === "N"} onChange={props.handleChange}/>
                              No
                            </label>
                            <label>
                              <input type="radio" name="isGovRecipients" value="Y" className="form-check-input" checked={props.data.isGovRecipients === "Y"} onChange={props.handleChange}/>
                              Yes
                            </label>
                            <label>(If Yes, please specify)</label>
                          </div>
                          <textarea disabled={!showGovRecipients} rows="3" className="full-width"  id="governmentRecipients" name="governmentRecipients" maxLength="500" value={props.data.governmentRecipients} onChange={props.handleChange}/>
                        </div>
                      </div>

                      { !isJwCole && 
                        <div className="form-item">
                          <label className={`form-item-label required ${validation.raffleContest ? "" : "warning" }`} htmlFor="raffleContest">Part of Contest or Raffle :</label>
                          <div className="form-item-value">
                            <div className="full-width label-group">
                              <label>
                                <input type="radio" name="isRaffleContest" value="N" className="form-check-input" checked={props.data.isRaffleContest === "N"} onChange={props.handleChange}/>
                                No
                              </label>
                              <label>
                                <input type="radio" name="isRaffleContest" value="Y" className="form-check-input" checked={props.data.isRaffleContest === "Y"} onChange={props.handleChange}/>
                                Yes
                              </label>
                              <label>(If Yes, please specify)</label>
                            </div>
                            <textarea rows="3" disabled={!showRaffleContest} className="full-width" id="raffleContest" name="raffleContest" maxLength="500" value={props.data.raffleContest} onChange={props.handleChange}/>
                          </div>
                        </div>
                      }

                      <div className="form-item">
                          <label className="form-item-label" htmlFor="attachment">Attachment Document :</label>
                          <div className="form-item-value">
                            <div className="placeholder">
                                <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                            </div>
                            <div>
                                <label className='form-item-label'>Include gift/entertainment receipts</label>
                            </div>
                          </div>
                      </div>

                      { appContext.user.submitOnBehalf && props.editorMode === 'NEW' &&
                          <UserSelectBox label='Submit On Behalf of (Optional) : ' styleClass='mt-3rem' onSelected={props.handleChange} name='submittedFor' value={ ()=> {return props.data.submittedFor?{value:props.data.submittedFor,label:props.data.submittedForLabel}:null}}/>
                      }

                    </div>

                  </div>

                </div>

            </div>
            <div className="form-footer">
                    {validation.valid ? (
                <div className="form-status"></div>
                ) : (
                    <div className="form-status error">Enter Required Information</div>
                )}
                <div className="btn-group">
                <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={props.handleCancel}>Cancel</button>
                <button id="btnReview" type="button" className="btn btn-primary" onClick={handleSaveClick}>Save and Review</button>
                </div>
            </div>
        </div>
    )

}


export default GiftFormComp;